module.exports = __webpack_public_path__ + "img/spa-bar.8f20ed4e.svg";